<template>
  <v-row>
    <v-col sm="auto">
      <h3 class="ml-8">
        {{ collection.name }}
      </h3></v-col
    >
    <v-col sm="auto">
      Created by: {{ collection.owner.name }}

      <div v-show="isSharer" light class="p-0 m-0 clearfix caption">
        Shared with:
        <span
          v-for="client in collection.shared_with_clients"
          :key="client.id"
          class="caption photo-meta caption"
        >
          {{ client.name }},
        </span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CollectionInfomation",

  computed: {
    isSharer() {
      if (
        this.collection.shared_with_clients &&
        this.collection.shared_with_clients.length &&
        this.activeExpClient.id === this.collection.owner.id
      ) {
        return true;
      }
      return false;
    },
    ...mapGetters(["currentUser", "activeExpClient", "collection"]),
  },
};
</script>
